import { validateCancelAccountToken } from '../services/accountService'

function fetchCancelAccountTokenValidate(token) {
  return () => validateCancelAccountToken(token)
}

export default fetchCancelAccountTokenValidate
